import { styled } from 'styled-components';
import * as Popover from '@radix-ui/react-popover';
import { Link } from '@/shared/ui/link';
import { Box } from '@/shared/ui/box/Box';
import { Image } from '@/shared/ui/image/Image';
import { Button } from '@/shared/ui/form/button/button';

export const Content = styled(Popover.Content)`
  display: flex;
  width: 400px;
  max-height: 560px;
  overflow-x: hidden;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: #131315;
  box-shadow: 0 18px 24px 0 rgba(19, 19, 21, 0.7);
  backdrop-filter: blur(18px);

  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    max-width: 100vw;
    max-height: 100%;
    height: 100%;
    border-radius: 0px;
    overflow: auto;
  }
`;

export const Root = styled(Popover.Root)`
  z-index: 100;
`;

export const ContentHeader = styled.div`
  padding: 18px 12px 10px 18px;
  display: flex;
  background: rgba(19, 19, 21, 0.75);
  backdrop-filter: blur(18px);
  justify-content: space-between;
  width: 100%;
  align-self: center;
  align-items: center;
  position: sticky;
  z-index: 100;
  top: 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 8px;
  background: rgba(19, 19, 21, 0.75);
  backdrop-filter: blur(18px);

  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const Item = styled(Link)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex: 1;
  gap: 12px;
  padding: 12px 12px 16px;
  border-radius: 8px;
  overflow: hidden;
  background: #27262b;
  //
`;
// ${({ $status }) =>
//   $status === 'success'
//     ? 'rgba(51, 63, 60, 0.75)'
//     : $status === 'error'
//       ? 'rgba(61, 51, 63, 0.75)'
//       : 'transparent'};

export const Status = styled.div<{ $status?: string }>`
  border-radius: 100px;
  width: 40px;
  height: 40px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #131315;
`;

// ${({ $status }) =>
//   $status === 'success' &&
//   `
// background: var(--Green, #08ad5e);
//  box-shadow:
//   0px 0px 80px 20px #08ad5e,
//   0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset;

// `}

// ${({ $status }) =>
//   $status === 'error' &&
//   `
// background: var(--Yellow, #DA4444);
// box-shadow:
//   0px 0px 80px 20px #FF3B30,
//   0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset;
// `}

// ${({ $status }) =>
//   $status != 'success' &&
//   $status != 'error' &&
//   `
// background: var(--1-f-78-ff, #131315);
// box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.06) inset, 0px 0px 80px 20px #131315;
// `}

export const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #edeff5;
  position: absolute;
  top: 0px;
  right: 4px;
`;

export const BoxTime = styled(Box)`
  position: absolute;
  right: 20px;
  @media (max-width: 270px) {
    bottom: 8px;
  }
`;

export const StatusIcon = styled(Image).withConfig({
  shouldForwardProp: (prop) => !['$status'].includes(prop),
})<{ $status?: string }>`
  display: flex;

  filter: ${
    ({ $status }) =>
      $status === 'success'
        ? 'brightness(0) saturate(100%) invert(54%) sepia(96%) saturate(1394%) hue-rotate(1deg) brightness(105%) contrast(104%)' // #FF9500
        : 'invert(70%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(90%)' // серый #AAAAAA
  };
`;

export const BellButton = styled(Button)`
  @media (max-width: 768px) {
    && {
      width: 40px;
      height: 40px;
    }
  }
`;

export const NotificationImage = styled(Image)`
  & img {
    height: 205px;
    border-radius: 8px;

    @media (max-width: 768px) {
      height: 160px;
    }
  }
`;
